import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Table from '../../../components/Table/Table';

export const TrainingBlock = ({ trainingsData, loading, handleRowClick }) => {
  const intl = useIntl();

  const displayedTrainings = trainingsData.trainings;

  // Define columns for MaterialTable
  const columns = [
    {
      title: intl.formatMessage({
        id: 'training.form.label.trainingName',
        defaultMessage: 'Training Name',
      }),
      field: 'trainingName',
    },
    {
      title: intl.formatMessage({
        id: 'training.form.label.trainingDate',
        defaultMessage: 'Training Date',
      }),
      field: 'trainingDate',
      type: 'datetime',
    },
    {
      title: intl.formatMessage({
        id: 'training.form.label.creator',
        defaultMessage: 'Creator',
      }),
      field: 'creator',
    },
    {
      title: intl.formatMessage({
        id: 'training.form.label.location',
        defaultMessage: 'Location',
      }),
      field: 'location',
    },
  ];

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <>
          <Table
            title={intl.formatMessage({
              id: 'training.form.title',
              defaultMessage: 'Training List',
            })}
            columns={columns}
            data={displayedTrainings}
            options={{
              search: true,
              paging: true,
            }}
            onRowClick={(event, rowData) => handleRowClick(rowData)}
          />
        </>
      )}
    </>
  );
};

TrainingBlock.propTypes = {
  trainingsData: PropTypes.shape({
    trainings: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        trainingName: PropTypes.string.isRequired,
        trainingDate: PropTypes.string.isRequired,
        creator: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  handleRowClick: PropTypes.func.isRequired,
};
